import React, { createContext, useState } from "react";
import { Flex, Card, Text, Badge, IconButton, Separator, DropdownMenu, Tooltip } from "@radix-ui/themes";
import { EllipsisHorizontalIcon } from "@heroicons/react/16/solid";
import { UserGroupIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import { CaretUpIcon, CaretDownIcon } from "@radix-ui/react-icons";
import "./ActiveIntegrateCard.css";

const ActiveIntegrateCardContext = createContext(null);

function Root({ name, subtitle, image_url, option, children, showLocationBadge = true }) {
  // For the image_url argument, make sure your image is inside the src/assets/images folder!
  // Specify the file extension of the image in the image_url argument.
  // This argument is required!!

  const [showDropdown, setShowDropdown] = useState(false);

  const handleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Update this condition to include Airship
  const lowerName = (name || "").toLowerCase();
  const isDropdownEnabled =
    lowerName === "mailchimp" ||
    lowerName === "airship" ||
    lowerName === "meta" ||
    lowerName === "atreemo" ||
    lowerName === "klaviyo" ||
    lowerName === "google ads" ||
    lowerName === "como" ||
    lowerName === "brevo" ||
    lowerName === "leat" ||
    lowerName === "sevenrooms" ||
    lowerName === "bloomreach" ||
    lowerName === "braze" ||
    lowerName === "dotdigital" ||
    lowerName === "whatsapp" ||
    lowerName === "google reviews" ||
    lowerName === "tripadvisor" ||
    lowerName === "tripadvisor reviews" ||
    lowerName === "tripadvisor-reviews" ||
    lowerName === "claude";

  return (
    <ActiveIntegrateCardContext.Provider value={{ showDropdown, handleShowDropdown }}>
      <Card style={{ display: "flex", padding: "var(--space-4)", flexDirection: "column", alignItems: "stretch",
        gap: "16px", alignSelf: "stretch", flex: "0 0 auto" }}>
        <Flex style={{ alignSelf: "stretch" }} justify="between" align="center" wrap="wrap" gap="3">
          <Flex display="flex" align="center" gap="4" style={{ minWidth: 0 }}>
            <Flex height="40px" width="40px" p="2" justify="center" align="center" gap="2"
              style={{ borderRadius: "var(--space-1)", background: "#FFFFFF", border: "1px solid var(--gray-a6)" }}>
              <img src={require(`../../assets/images/${image_url}`)} alt="icon" style={{ width: "24px", borderRadius: "var(--space-1)" }} />
            </Flex>
            <Flex className="frame-528173402" display="flex" direction="column" justify="center" align="start">
              <Text size="4" weight="medium">{name}</Text>
              <Text size="1" color="gray">{subtitle}</Text>
            </Flex>
          </Flex>
          <Flex align="center" gap="5">
            {showLocationBadge ? (
              <Badge size="1" variant="outline" color="gray">All locations</Badge>
            ) : null}
            <Badge size="1" variant="soft" color="green">Connected</Badge>
            <Flex align="center" gap="4">
              <DropdownMenu.Root>
                <DropdownMenu.Trigger asChild>
                  <Flex display="flex" width="var(--space-5)" height="var(--space-5)" justify="center" align="center">
                    <IconButton size="1" variant="ghost" color="gray">
                      <EllipsisHorizontalIcon width="16" height="16" />
                    </IconButton>
                  </Flex>
                </DropdownMenu.Trigger>
                <DropdownMenu.Content>
                  <DropdownMenu.Item onClick={option.onClick} color={option.color}>
                    {option.text}
                  </DropdownMenu.Item>
                </DropdownMenu.Content>
              </DropdownMenu.Root>
              <Flex width="var(--space-5)" height="var(--space-5)" justify="center" align="center">
                <Tooltip content={isDropdownEnabled ? "View integration settings" : "Integration settings coming soon"}>
                  <IconButton onClick={handleShowDropdown} size="1" variant="ghost" color="gray" disabled={!isDropdownEnabled}>
                    {showDropdown ? <CaretUpIcon width="16" height="16" /> : <CaretDownIcon width="16" height="16" />}
                  </IconButton>
                </Tooltip>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        {showDropdown ? children : null}
      </Card>
    </ActiveIntegrateCardContext.Provider>
  );
}

function Section({ name, subtitle, note, children }) {
  return (
    <React.Fragment>
      <Separator orientation="horizontal" size="4" style={{ minHeight: '1px'}} />
      <div className="aic-section">
        <div className="aic-section__label">
          <Flex gap="2" align="center" style={{alignSelf: 'stretch'}}>
            { name.toLowerCase().includes("linked audience") && (
              <UserGroupIcon width={14} height={14} />
            )}
            { name.toLowerCase().includes("data fields") && (
              <TableCellsIcon width={14} height={14} />
            )}
            <Text size="3" weight="medium">{name}</Text>
          </Flex>
          <Text size="1" color="gray">{subtitle}</Text>
          {note ? (
            <Text size="1" weight="regular">
              <strong>Note:</strong> {note}
            </Text>
          ) : null}
        </div>
        <div className="aic-section__body">
          {children}
        </div>
      </div>
    </React.Fragment>
  );
}

export const ActiveIntegrateCard = {
  Root,
  Section,
};
